import { useEffect } from "react";
import { useParams } from "react-router";

import { buildRoute } from "sj-ui-toolkit/src/constants/routes";
import { useSmartNavigation } from "sj-ui-toolkit/src/helpers/navigation";

const AssessmentRedirect = () => {
  const { assignmentId } = useParams();
  const { navigateTo } = useSmartNavigation();

  useEffect(() => {
    navigateTo(buildRoute("Ka.routes.assignment.route", { assignmentId: assignmentId }));
  }, [assignmentId, navigateTo]);

  // Announce navigation to assistive tech instead of rendering nothing during the redirect.
  return (
    <div role="status" aria-live="polite" aria-busy="true" className="sr-only">
      Opening assessment, please wait…
    </div>
  );
};

export default AssessmentRedirect;
